gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const slideshows = document.querySelectorAll(".resource-list__carousel");
  const blogs = document.querySelectorAll("[class*='blog-latest-carousel-']");

  [...slideshows, ...blogs].forEach((slideshow) => {
    if (slideshow.dataset.scrollAnimInit) return;
    slideshow.dataset.scrollAnimInit = "true";

    const targets =
      slideshow.querySelectorAll(".resource-list__carousel, [class*='blog-carousel-wrapper-']");
    if (!targets.length) return;

    // 🧩 Force stable GPU compositing
    targets.forEach((el) => {
      el.style.willChange = "transform, opacity";
      el.style.transform = "translateZ(0)";
      el.style.backfaceVisibility = "hidden";
      el.style.webkitTransform = "translateZ(0)";
      el.style.webkitBackfaceVisibility = "hidden";
    });

    // Initial hidden state
    gsap.set(targets, { x: 60, opacity: 0 });

    // Animation
    ScrollTrigger.create({
      trigger: slideshow,
      start: "top 80%",
      once: true,
      onEnter: () => {
        gsap.to(targets, {
          x: 0,
          opacity: 1,
          duration: 0.4,
          stagger: 0.1,
          ease: "power2.out",
          onComplete: () => {
            // Lock GPU layer so Safari doesn’t drop it
            targets.forEach((el) => {
              el.style.transform = "translate3d(0,0,0)";
              el.style.willChange = "auto";
            });
          },
        });
      },
    });
  });
});
